<template>
  <section class="home-product  home-container">
    <h3 class="home-title">平台优势</h3>
    <div class="home-product__container">
      <div class="homeProduct-item" v-for="(item,index) in products" :key="index">
        <input type="radio" name="product" :id='"p"+index' class="homeProduct-item__input" :checked="index===detail.activeIndex" @change="inputChange(index)">
        <label class="homeProduct-label" :for='"p"+index'>
          <p class="homeProduct-item__icon">
              <img :src="item.src" :alt="item.title">
          </p>
          <p class="homeProduct-item__text">
              {{item.title}}
          </p>
        </label>
      </div>
    </div>
      <div class="homeProduct-detail" :data-activeIndex="detail.activeIndex">
        <div class="homeProduct-detail__icon">
            <img :src="detail.src" :alt="detail.title"  class="homeProduct-detail__img">
        </div>
        <div class="homeProduct-detail__right">
          <h4 class="homeProduct-detail__title">
              {{detail.title}}
          </h4>
          <p class="homeProduct-detail__text">
              {{detail.content}}
          </p>
        </div>
      </div>
		</section>
</template>

<script>
export default {
    name: 'home-product',
    data(){
        return {
            products: [{
              id: 0,
              title: '开放中立',
              content: '开放、中立和融合的AI平台技术产品和服务，支持多种开源深度学习框架，不绑定任何特定的技术和服务框架。',
              src: require('../../assets/images/open.png')
            }, {
              id: 1,
              title: '极致性能',
              content: '各类框架运行于GPU服务器。超强算力的GPU集群的支撑以及先进的云平台技术提供高并行、高吞吐、低时延的极致性能。在科学计算表现中性能比传统架构提高50倍。',
              src: require('../../assets/images/performance.png')
            }, {
              id: 2,
              title: '弹性灵活',
              content: '平台可随时创建深度学习训练环境和训练任务，灵活配置资源满足不同场景需求。高效的机器学习运维管理 (MLOps) 全流程支持 AI 模型的构建、训练和部署。',
              src: require('../../assets/images/flexibility.png')
            }, {
              id: 3,
              title: '开箱即用',
              content: '平台预置TensorFlow, PyTorch 和 MxNet等近十种人工智能开源框架，一键快速提交训练任务。数据模型分析交互式开发工具 MLab，支持一键添加代码和数据集。',
              src: require('../../assets/images/box-use.png')
            }, {
              id: 4,
              title: '成本优化',
              content: '高效的资源优化调度和管理显著地降低资源使用和运维成本；多种计费模式极大地降低前期投入。',
              src: require('../../assets/images/save.png')
            }, {
              id: 5,
              title: '安全服务',
              content: '平台完善的隔离及网络监控服务，保障用户数据和服务安全无虞。',
              src: require('../../assets/images/safe-service.png')
            }],
            detail: {
                img: '',
                title: '',
                text: '',
                activeIndex: 0
            }
        }
    },
    props: {

    },
    mounted: function(){
        if(this.products.length) {
            this.detail = {...this.products[0],activeIndex:0};
        }
    },
    methods: {
        inputChange(index){
            this.detail = {...this.products[index],activeIndex:index};
        }
    }

}
</script>

<style scoped>

.home-product__container{
    display: flex;
}
.homeProduct-item {
    flex: 1;
     line-height: 1;
     text-align: center;
}
.homeProduct-item__input {
    position: absolute;
    max-width: 0;
    clip: rect(0 0 0 0);
}
.homeProduct-label  {
    color: rgba(206, 230, 233, 1);
    opacity: .5;
    cursor: pointer;
}
.homeProduct-item__input:checked + .homeProduct-label {
    color: #3B3A40;
    opacity: 1;
}
.homeProduct-item__icon {
  height: 9vw;
  overflow: hidden;
  color:rgba(52,156,227,1);
}
.homeProduct-item__icon img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.homeProduct-item__text {
    position: relative;
    margin-top: 2.8vw;
    font-size: 3.2vw;

}
.homeProduct-item__text:after{
    position: absolute;
    bottom:  -6.933333333333334vw;
    left: 50%;
    display: none;
    border: 1.6vw solid rgba(52,156,227,0.1);
    border-top: 0 none;
    border-right-color: transparent;
    border-left-color: transparent;
    content: '';
    transform: translateX(-50%);
 }
 .homeProduct-item__input:checked + .homeProduct-label>.homeProduct-item__text:after {
     display: inline-block;
 }
.homeProduct-detail {
    padding: 4.266666666666667vw 3.2vw;
    border-radius:0.5333333333333333vw;
    margin: 6.933333333333334vw auto 0;
    overflow: hidden;
    background:rgba(4,63,106,1);
    box-sizing: border-box;
    box-shadow:0vw 1.6vw 2.1333333333333333vw 0vw rgba(37,53,73,0.06);

}

.homeProduct-detail__icon {
    float: left;
    margin-right: 6vw;
}
.homeProduct-detail__img {
    width: 13.2vw;
}
.homeProduct-detail__right {
    padding-top: 0.4vw;
    overflow: hidden;
    color: #fff;
    text-align: left;
}
.homeProduct-detail__title {
    font-weight: bold;
    font-size: 3.7333333333333334vw;
}
.homeProduct-detail__title:not(:empty):before {
    display: inline-block;
    width: 0.6666666666666666vw;
    height: 1em;
    border-radius: 0.6666666666666666vw;
    color: transparent;
    content: '.';
    background:#00D5DF;
}
.homeProduct-detail__text {
    margin-top: 1.6vw;
    font-size: 3.2vw;
    line-height: 2;
    color:rgba(166,183,206,1);
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/ai-advantages.vue